import { types as sdkTypes } from '../util/sdkLoader';
import { REVIEW_TYPE_OF_PROVIDER } from '../util/types';

const { UUID } = sdkTypes;

const STORE_PROVIDED_SOURCE_LABEL = 'Store-provided';

const createManualReview = ({ id, authorName, rating, content, createdAt }) => ({
  id: new UUID(id),
  attributes: {
    createdAt: new Date(createdAt),
    content,
    rating,
    state: 'public',
    type: REVIEW_TYPE_OF_PROVIDER,
    sourceLabel: STORE_PROVIDED_SOURCE_LABEL,
  },
  author: {
    id: new UUID(id),
    type: 'user',
    attributes: {
      banned: false,
      deleted: false,
      profile: {
        displayName: authorName,
        abbreviatedName: authorName
          .split(/\s+/)
          .map(part => part.charAt(0))
          .join('')
          .slice(0, 2)
          .toUpperCase(),
      },
    },
  },
});

const manualStoreReviewsByUserId = {
  '6976d360-60ab-4148-8cd1-033aa64c5195': [
    createManualReview({
      id: 'b0ef4ec5-a0ef-4637-b3e1-9f19eddbfa01',
      authorName: 'Amanda R.',
      rating: 5,
      content:
        'For my daughter’s birthday, I decided to order a balloon garland. I ended up using the chat on the site because the checkout was having an issue with how I entered the zip code. I’m really glad I did! The customer service was very good, and they helped make the balloon garland even better and more exactly what I was looking for. It was installed early in the morning, right in time for my daughter’s birthday, and she loved it!',
      createdAt: '2026-04-21T12:00:00.000Z',
    }),
    createManualReview({
      id: '4b1678d6-51f9-4c33-95ad-13d0e39843d2',
      authorName: 'Melissa T.',
      rating: 5,
      content:
        'Would definitely use Mood Balloons again! I worked with Svetlana from Mood Balloons to create a custom balloon garland and backdrop for a baby shower. She helped me put together a beautiful setup — everything turned out great. Delivery and pickup were smooth and on time, and she was very easy to work with!',
      createdAt: '2026-04-13T12:00:00.000Z',
    }),
    createManualReview({
      id: 'cf2059c8-c3c0-4889-a301-3c8e23b59ec3',
      authorName: 'Daniela M.',
      rating: 5,
      content:
        'Mood Balloons would get 10 stars from me if LocalFlower allowed it. Always quick to reply and is our go-to for events.',
      createdAt: '2026-04-04T12:00:00.000Z',
    }),
    createManualReview({
      id: '7fcf4545-c7b4-43ed-a872-92d52d7b6ef4',
      authorName: 'Kristina L.',
      rating: 5,
      content:
        'Mood Balloons literally comes up with the BEST creative ideas for any theme or party concept/event. Svetlana is my go-to for everything beautiful when you want that extra special look. Thanks for being so awesome and easy to work with!',
      createdAt: '2026-03-26T12:00:00.000Z',
    }),
    createManualReview({
      id: '7da89a83-a78f-413f-932c-aec6ef4d75e2',
      authorName: 'Natalia S.',
      rating: 5,
      content:
        'We are so happy we went with Svetlana for our daughters Quinceañera. Everything looked beautiful, honestly even better then we expected. The chairs, the stairs, all details just came together. She made it very easy for us, no stress at all. Would recommend for sure',
      createdAt: '2026-03-18T12:00:00.000Z',
    }),
    createManualReview({
      id: 'a5744535-b6c1-440e-82e4-5e574a860153',
      authorName: 'Irina K.',
      rating: 5,
      content:
        'They did decor for my moms birthday. Everything looked very nice and simple but elegant. Quality is good , nothing cheap looking. Happy with the result.',
      createdAt: '2026-03-09T12:00:00.000Z',
    }),
    createManualReview({
      id: 'fb3bdaf8-dbf6-4c6a-bfb5-4c0fb5a71de5',
      authorName: 'Lana P.',
      rating: 5,
      content:
        'We first saw her work at another party and decided to try. She helped us choose colors and style. Result came out even nicer then pictures we showed her !!',
      createdAt: '2026-02-27T12:00:00.000Z',
    }),
    createManualReview({
      id: '5a9f15b1-c361-450d-8a1f-96059a8d012d',
      authorName: 'Victoria N.',
      rating: 5,
      content:
        'Worked with Svetlana twice now. Communication is good , she answers and explains everything. Flexible with ideas which is nice.',
      createdAt: '2026-02-15T12:00:00.000Z',
    }),
    createManualReview({
      id: 'ef9e2082-ad77-4450-a594-9ed695fa6ac3',
      authorName: 'Mila G.',
      rating: 5,
      content: 'Professional team , everything done as discussed. No surprises',
      createdAt: '2026-02-02T12:00:00.000Z',
    }),
  ],
  '68e2bc2f-0209-470c-a0aa-85de0d876452': [
    createManualReview({
      id: '8f1b6d54-2a09-4d8c-9e73-c5a4f0b2e981',
      authorName: 'Brian K.',
      rating: 5,
      content:
        'They were awesome!! Responsive, punctual so easy to work with on the phone and the flowers themselves were stunning!!',
      createdAt: '2026-05-02T12:00:00.000Z',
    }),
    createManualReview({
      id: '6e3a1c97-b0d5-4f82-a614-7c8b9e0d3f25',
      authorName: 'Rachel P.',
      rating: 5,
      content:
        'The delivery was spot on! I was so excited to get the text that the flowers had been delivered!',
      createdAt: '2026-04-22T12:00:00.000Z',
    }),
    createManualReview({
      id: '4d9f7c20-5e8a-4193-bc67-1a2f3b4c5d6e',
      authorName: 'David S.',
      rating: 5,
      content:
        'Ordered online for same day delivery and everything went according to plan! The recipient sent me a photo of the flowers delivered to her. They were beautiful and she was delighted.',
      createdAt: '2026-04-10T12:00:00.000Z',
    }),
    createManualReview({
      id: 'a17b8f43-e609-4c52-9d8e-2b3c4d5e6f70',
      authorName: 'Lauren H.',
      rating: 5,
      content:
        'Created an even more beautiful bouquet than I expected. They were really helpful with my order over the phone and delivered it with care. Highly recommend!',
      createdAt: '2026-03-28T12:00:00.000Z',
    }),
    createManualReview({
      id: 'c92e5b08-71fd-4ab3-86c4-9f8e7d6c5b4a',
      authorName: 'Megan T.',
      rating: 5,
      content:
        'I ordered flowers for my parents anniversary last minute. The team put together a beautiful arrangement and delivered them same day! My parents loved them. Thank you!',
      createdAt: '2026-03-15T12:00:00.000Z',
    }),
    createManualReview({
      id: '3b5d8e2a-49c7-4f01-b8e6-7a1c2b3d4e5f',
      authorName: 'Caroline B.',
      rating: 5,
      content:
        'Wow! This is the first time we used you and my sister just sent a photo of the arrangement we sent her. It was delivered on time and was gorgeous! She said she will now use you, and we most certainly will!',
      createdAt: '2026-03-01T12:00:00.000Z',
    }),
    createManualReview({
      id: 'd2c4a8e1-3f7b-42a9-b056-1e8f9d4a5c30',
      authorName: 'Jessica M.',
      rating: 5,
      content:
        'I had a bouquet delivered to my mom for Valentine’s Day, and she said it was the prettiest arrangement she’s ever received! 10/10 recommend!',
      createdAt: '2026-02-18T12:00:00.000Z',
    }),
  ],
};

export const getManualStoreReviews = userId =>
  userId ? manualStoreReviewsByUserId[userId] || [] : [];

export const getManualStoreRatingData = userId => {
  const reviews = getManualStoreReviews(userId);
  const reviewCount = reviews.length;

  if (!reviewCount) {
    return null;
  }

  const ratingTotal = reviews.reduce((sum, review) => sum + review.attributes.rating, 0);
  const ratingAverage = ratingTotal / reviewCount;

  return {
    rating: ratingAverage,
    ratingPercent: Math.round(ratingAverage * 100),
    reviewCount,
  };
};
